import SurveyTip from 'components/pages/SurveyTip/SurveyTip';
import { buildPage, buildStaticProps } from 'utils/pageHelper';
import { GetStaticPaths, GetStaticProps } from 'next/types';
import QmeeSurveyTips from 'constants/QmeeSurveyTips';

export default buildPage(SurveyTip, {
  requiresAuthentication: false,
  withNestedMetaData: true,
  // fullPage: true,
});

function generateSurveyTips(locale: string | undefined = undefined) {
  return QmeeSurveyTips.map((tip) => ({
    params: { surveyTipSlug: tip.path },
    locale,
  }));
}

export const getStaticPaths: GetStaticPaths = async function getStaticPaths(context) {
  const surveyTips = (context.locales || []).reduce((acc, locale) => {
    return [...acc, ...generateSurveyTips(locale)];
  }, generateSurveyTips());

  return {
    paths: surveyTips,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { params } = context;
  const surveyTipSlug = params?.surveyTipSlug as string;
  const surveyTipIndex = QmeeSurveyTips.map((tip) => tip.path).indexOf(surveyTipSlug);

  const base = await buildStaticProps('survey-tips')(context);

  return {
    ...base,
    props: {
      ...(base as { props: object }).props,
      surveyTips: QmeeSurveyTips,
      surveyTipIndex,
    },
  };
};
